import React from 'react';

const FeaturesContext = React.createContext({
  features: [],
  setFeatures: () => {},
});

export default FeaturesContext;
